import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { JSONTransformer } from '@atlaskit/editor-json-transformer';
import { getContentPropertyIdFromAri, getPageIdFromAri } from '../ui/extensions/synced-block/utils/ari';
import { getContentProperty, updateContentProperty } from '../ui/extensions/synced-block/utils/content-property';
import { parseSyncedBlockContentPropertyValue, stringifySyncedBlockContentPropertyValue } from '../ui/extensions/synced-block/utils/synced-block';
var transformer = new JSONTransformer();
var toJSON = function toJSON(node) {
  return transformer.encodeNode(node);
};
var getCacheKey = function getCacheKey(_ref) {
  var sourceDocumentAri = _ref.sourceDocumentAri,
    contentAri = _ref.contentAri,
    contentPropertyKey = _ref.contentPropertyKey;
  return "".concat(sourceDocumentAri, "-").concat(contentAri, "-").concat(contentPropertyKey);
};
export var SyncClient = /*#__PURE__*/function () {
  function SyncClient() {
    _classCallCheck(this, SyncClient);
    _defineProperty(this, "requestMap", new Map());
    this.requestMap = new Map();
  }
  return _createClass(SyncClient, [{
    key: "getRequestState",
    value: function getRequestState(key) {
      return this.requestMap.get(key);
    }
  }, {
    key: "setRequestState",
    value: function setRequestState(key, state) {
      this.requestMap.set(key, state);
    }
  }, {
    key: "sendRequest",
    value: function () {
      var _sendRequest = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref2) {
        var sourceDocumentAri, contentAri, contentPropertyKey, value, pageId, contentPropertyId, contentProperty, updatedValue;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              sourceDocumentAri = _ref2.sourceDocumentAri, contentAri = _ref2.contentAri, contentPropertyKey = _ref2.contentPropertyKey, value = _ref2.value;
              pageId = getPageIdFromAri(sourceDocumentAri);
              contentPropertyId = getContentPropertyIdFromAri(contentAri);
              _context.prev = 3;
              _context.next = 6;
              return getContentProperty({
                pageId: pageId,
                contentPropertyId: contentPropertyId
              });
            case 6:
              contentProperty = _context.sent;
              updatedValue = stringifySyncedBlockContentPropertyValue(_objectSpread(_objectSpread({}, parseSyncedBlockContentPropertyValue(contentProperty.value)), JSON.parse(value)));
              _context.next = 10;
              return updateContentProperty({
                pageId: pageId,
                key: contentPropertyKey,
                value: updatedValue,
                signal: undefined
              });
            case 10:
              _context.next = 15;
              break;
            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              // eslint-disable-next-line no-console
              console.error('Failed to update content property:', _context.t0);
            case 15:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 12]]);
      }));
      function sendRequest(_x) {
        return _sendRequest.apply(this, arguments);
      }
      return sendRequest;
    }()
  }, {
    key: "syncContent",
    value: function syncContent(_ref3) {
      var _this = this;
      var sourceDocumentAri = _ref3.sourceDocumentAri,
        contentAri = _ref3.contentAri,
        contentPropertyKey = _ref3.contentPropertyKey,
        node = _ref3.node;
      var nodeAdf = toJSON(node);
      var key = getCacheKey({
        sourceDocumentAri: sourceDocumentAri,
        contentAri: contentAri,
        contentPropertyKey: contentPropertyKey
      });
      var value = stringifySyncedBlockContentPropertyValue({
        adf: nodeAdf
      });
      var requestState = this.getRequestState(key) || {
        timeout: null,
        pendingValue: null,
        isSending: false
      };
      requestState.pendingValue = value;
      if (requestState.isSending) {
        return;
      }
      if (requestState.timeout) {
        clearTimeout(requestState.timeout);
      }
      var send = /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                if (!requestState.isSending) {
                  _context2.next = 2;
                  break;
                }
                return _context2.abrupt("return");
              case 2:
                requestState.isSending = true;
                _context2.prev = 3;
                _context2.next = 6;
                return _this.sendRequest({
                  sourceDocumentAri: sourceDocumentAri,
                  contentAri: contentAri,
                  contentPropertyKey: contentPropertyKey,
                  value: requestState.pendingValue || ''
                });
              case 6:
                requestState.pendingValue = null;
                _context2.next = 12;
                break;
              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](3);
                // eslint-disable-next-line no-console
                console.error('Failed to send synced block content:', _context2.t0);
              case 12:
                _context2.prev = 12;
                requestState.isSending = false;
                return _context2.finish(12);
              case 15:
              case "end":
                return _context2.stop();
            }
          }, _callee2, null, [[3, 9, 12, 15]]);
        }));
        return function send() {
          return _ref4.apply(this, arguments);
        };
      }();
      requestState.timeout = setTimeout(send, 1000);
      this.setRequestState(key, requestState);
    }
  }]);
}();